import React from "react";
import { Translate } from "react-localize-redux";
import { useUpdateContactInviteRequest } from "../../redux/effects/contacts.effects";
import { ACCEPTED, REJECTED } from "../../constants/contact.constants";
import "./styles.scss";

const ContactInviteCard = ({ invite }) => {
  const updateContactInvite = useUpdateContactInviteRequest();

  return (
    <div className="invite-card-container">
      <div className="row">
        <div className="col-4">
          <div
            className="invite-card-img"
            style={{
              backgroundImage: `url(${invite.creator.image_url})`
            }}
          />
        </div>
        <div className="col-8">
          <div className="row">
            <div className="col-12">
              <h5 className="invite-card-name-text">
                {invite.creator.first_name} {invite.creator.last_name}{" "}
              </h5>
              <h6 className="invite-card-name-text">
                {invite.creator.city}, {invite.creator.country}{" "}
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div className="row contact-button-container">
        <div className="col-6">
          <button
            className="btn btn-primary btn-block btn-sm"
            onClick={() => updateContactInvite(invite.id, ACCEPTED)}
          >
            <Translate id="accept" />
          </button>
        </div>
        <div className="col-6">
          <button
            className="btn btn-primary btn-block btn-sm"
            onClick={() => updateContactInvite(invite.id, REJECTED)}
          >
            <Translate id="decline" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactInviteCard;

/*

{
  "id": 3,
  "creator": {
    "id": 105,
    "slug": "steve-johnson",
    "fb_id": null,
    "image_url": "https://res.cloudinary.com/myhellohello/image/upload/v1554298510/ucdybqc8mbc2vdsbioxe.jpg",
    "first_name": "",
    "middle_name": "",
    "last_name": "",
    "city": "London",
    "country": "England",
    "email": "sean.wiseman@hotmail.co.uk",
    "work_place": null,
    "occupation": null,
    "validated_phone_number": "447540611552",
    "prof_designations": null,
    "privacy": "PU",
    "first_name_privacy": "PU",
    "last_name_privacy": "PU",
    "occupation_privacy": "PU",
    "work_place_privacy": "PU",
    "prof_des_privacy": "PU",
    "photo_privacy": "PU",
    "user": 105,
    "contacts": []
  },
  "target": {
    "id": 100,
    "slug": "sean-wiseman-9",
    "fb_id": null,
    "image_url": "https://res.cloudinary.com/myhellohello/image/upload/v1554298713/100/ieua884vd0x8neelieqq.jpg",
    "first_name": "Sean",
    "middle_name": null,
    "last_name": "Wiseman",
    "city": "London",
    "country": "United Kingdom",
    "email": "sam@testman.com",
    "work_place": null,
    "occupation": null,
    "validated_phone_number": "447540611552",
    "prof_designations": null,
    "privacy": "PU",
    "first_name_privacy": "PU",
    "last_name_privacy": "PU",
    "occupation_privacy": "PU",
    "work_place_privacy": "PU",
    "prof_des_privacy": "PU",
    "photo_privacy": "PU",
    "user": 100,
    "contacts": []
  },
  "created": "2019-05-07T20:18:35.842595Z",
  "status": "Pending"
}

*/



// WEBPACK FOOTER //
// ./src/components/ContactInviteCard/ContactInviteCard.jsx